import React, { useEffect, useState } from 'react';
import {
  Button, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip, Box, CircularProgress
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import CheckIcon from '@mui/icons-material/Check';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import api, { goToSwitchOrg } from '../api';

// Organization switcher for the top bar. Lists the orgs the signed-in user belongs to (from the
// product's own /api/organizations) and switches to another WITHOUT re-entering credentials — the
// gateway re-federates silently. The product never talks to Auth0; it only calls the gateway.
const OrgSwitcher = () => {
  const [orgs, setOrgs] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api
      .get('/organizations')
      .then((res) => {
        if (active) setOrgs(res.data?.organizations || []);
      })
      .catch(() => {
        /* non-fatal — the switcher just won't render */
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  if (loading) return <CircularProgress size={18} sx={{ mx: 1 }} />;
  if (orgs.length < 2) return null; // nothing to switch to

  const current = orgs.find((o) => o.current);

  const pick = (org) => {
    setAnchorEl(null);
    if (!org.current) goToSwitchOrg(org.milientOrgId);
  };

  return (
    <Box>
      <Tooltip title="Switch organization">
        <Button
          onClick={(e) => setAnchorEl(e.currentTarget)}
          startIcon={<BusinessIcon />}
          endIcon={<ExpandMoreIcon />}
          color="inherit"
          size="small"
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          {current?.name || 'Select organization'}
        </Button>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(null)}>
        {orgs.map((org) => (
          <MenuItem key={org.id} selected={!!org.current} onClick={() => pick(org)}>
            <ListItemIcon>{org.current ? <CheckIcon fontSize="small" /> : null}</ListItemIcon>
            <ListItemText primary={org.name} secondary={org.milientOrgId} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default OrgSwitcher;
